import { SignInBase } from "../Root/sign-in-base";

export class SignIn extends SignInBase {
    public static Init(): void {
        new SignIn();
    }

    constructor() {
        super("sign-in", "/register-customer", "/ws/verify-login", "/ws/set-password");
    }
}

if (document.body.dataset.pageInit == "sign-in-account") {
    SignIn.Init();
}
